import React from "react";
import {
	Container,
	Box,
	Typography,
	Alert,
	CircularProgress,
} from "@mui/material";

import { SiteAuthHeader } from "../../components/AuthHeader";
import { SiteRouterLink } from "../../../components/RouterLink";
import { AuthPaper } from "../../components/AuthPaper";
import { useI18n } from "./locales";
import { papi } from "@haohan-frontend/papi";
import { Helmet } from "react-helmet-async";
import {  useParams } from "react-router-dom";
import { AxiosError } from "axios";

export function AuthVerifyEmailFinal() {
	const { t, Trans } = useI18n();
	const { token } = useParams();
	const [loading, setLoading] = React.useState(true);
	const [ success, setSuccess ] = React.useState(false);
	const [ tokenInvalid, setTokenInvalid ] = React.useState(false);
	let content = null;
	if (loading) {
		content = (
			<Box display='flex' justifyContent='center' p={3}>
				<CircularProgress size={28} />
			</Box>
		);
	}

	if (success) {
		content = (
			<Alert severity="success">
				{t("Email is verified")}.{' '}
				<Trans
					i18nKey="Now you can <0>Login in your account</0>"
					components={[
						<SiteRouterLink to="/auth/login" underline="hover" />
					]}
				/>
			</Alert>
		);
	}

	if (tokenInvalid) {
		content = (
			<Alert severity="error">
				{t("Email verification failed")}. {t('Link is outdated or invalid')}.
			</Alert>
		);
	}

	const verifyFinal = async () => {
		try {
			const res = await papi.auth.finishVerifyEmail({token});
			if (res.success) {
				setSuccess(true);
			}
		} catch (err) {
			const e = err as AxiosError;
			if (e.response.status === 400) {
				setTokenInvalid(true);
			}
		}
		setLoading(false);
	}

	React.useEffect(() => {
		verifyFinal();
	}, []);

	return (
		<>
			<Helmet>
				<title>{t('Email verification')} — Haohan</title>
			</Helmet>
			<SiteAuthHeader/>
			<main>
				<Container maxWidth="xs" sx={{pb: 8, pt: 14}}>
					<AuthPaper
						rightColumn={(
							<>
								<Typography
									display='block'
									fontWeight='bold'
									mb={.5}
									textAlign='center'
									variant='h6'
								>
									{t('Email verification')}
								</Typography>
								<Box position='relative' mt={2}>
									{content}
								</Box>
							</>
						)}
					/>
				</Container>
			</main>
		</>
	);
}
